/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyUserSegmentation: LazyComponent<() => React.JSX.Element> = lazyForPaint(() =>
	markAsProductBundleReady(
		// eslint-disable-next-line jira/import/file-extension-required
		import(
			/* webpackChunkName: "async-user-segmentation", jiraSpaEntry: "async-user-segmentation" */ '@jira/platform__user-segmentation'
		),
	),
);

export const UserSegmentation = (): React.JSX.Element => (
	<LazyPage Page={LazyUserSegmentation} pageId="user-segmentation" shouldShowSpinner />
);
